import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initReveals() {
  document.querySelectorAll('.manifesto__line').forEach((line, i) => {
    gsap.from(line, {
      y: 60,
      opacity: 0,
      duration: 1,
      ease: 'expo.out',
      delay: i * 0.04,
      scrollTrigger: { trigger: line, start: 'top 88%' },
    });
  });

  document.querySelectorAll('.section-marker__title').forEach((el) => {
    gsap.from(el, {
      y: 80,
      opacity: 0,
      duration: 1.2,
      ease: 'expo.out',
      scrollTrigger: { trigger: el, start: 'top 88%' },
    });
  });

  document.querySelectorAll('.grid__tile').forEach((tile, i) => {
    gsap.from(tile, {
      y: 60,
      opacity: 0,
      duration: 0.95,
      ease: 'expo.out',
      delay: (i % 2) * 0.08,
      scrollTrigger: { trigger: tile, start: 'top 90%' },
    });
  });

  document.querySelectorAll('.services__stack a').forEach((a, i) => {
    gsap.from(a, {
      y: 40,
      opacity: 0,
      duration: 0.8,
      ease: 'expo.out',
      delay: i * 0.03,
      scrollTrigger: { trigger: a, start: 'top 92%' },
    });
  });

  document.querySelectorAll('.feature__chip').forEach((chip, i) => {
    gsap.from(chip, {
      scale: 0.4,
      rotate: 0,
      opacity: 0,
      duration: 1.1,
      ease: 'expo.out',
      delay: i * 0.08,
      scrollTrigger: { trigger: chip.closest('.feature'), start: 'top 70%' },
    });
  });

  const cta = document.querySelector('.cta__title');
  if (cta) {
    ScrollTrigger.create({
      trigger: cta,
      start: 'top 80%',
      onEnter: () => cta.classList.add('is-in'),
    });
  }

  const wm = document.querySelector('.end__wordmark [data-split]');
  if (wm) {
    ScrollTrigger.create({
      trigger: wm,
      start: 'top 95%',
      onEnter: () => wm.classList.add('is-in'),
    });
  }
}
